export const NODE_WIDTH = 350;
